import Dialog from "@mui/material/Dialog";
import PriorityOptions from "../../utils/priorityOptions";
import * as React from "react";
import {useDispatch} from "react-redux";
import _ from "lodash";
import {saveAgylePreference} from "../../../store/reducers/preferences";
import {useEffect} from "react";

export function getColumns (columnsInit, savePref ) {
    let init = [...columnsInit];
    if (savePref && !_.isEmpty(savePref)) {
        const cloneProperties = _.cloneDeep(savePref);
        const loadData = [];

        _.forEach(init, col => {
            const find = _.find(cloneProperties, {id: col.name});
            loadData.push({
                ...col,
                order: find ? find.order : col.order
            });
        });
        init = [...loadData];
    }

    return [...init];
}

function ColumnsManager(props)  {
    const dispatch = useDispatch();

    const [openConfig, setOpenConfig] = React.useState(props.openConfig);
    const [columns, setColumns] = React.useState(props.columns)


    useEffect(()=>{
        setOpenConfig(props.openConfig)
    },[props.openConfig]);

    useEffect(()=>{
        setColumns(props.columns)
    },[props.columns]);

    const handleCloseSettings = () => {
        if(props.closeModal)
            props.closeModal()
        setOpenConfig(false);
    };


    const handleChangeColumns = (activeColumns, disableColumns) => {
        const disabled = [];
        const active = [];

        for (let i = 0; i < activeColumns.length; i++) {
            active.push({
                ...activeColumns[i],
                order: i + 1
            });
        }

        _.forEach(disableColumns, col => {
            disabled.push(
                {
                    ...col,
                    order: null,
                }
            );
        });
        const newList = [...active, ...disabled];

        setColumns([...newList]);

        const userPref = [];
        _.forEach(newList, column => {
            userPref.push({
                id: column.name,
                order: column.order
            });
        });

        dispatch(saveAgylePreference({[props.prefPath]: [...userPref]}));
        handleCloseSettings()
    };

    // Restore Default Layout
    const setDefaultLayout = () => {
        setColumns([...props.columnsInit]);
        dispatch(saveAgylePreference({[props.prefPath]: null}));
        handleCloseSettings()
    };


    return (
        <Dialog
            open={openConfig}
            maxWidth={"md"}
            fullWidth={true}
            onClose={handleCloseSettings}
        >
            <PriorityOptions
                onClose={handleCloseSettings}
                columns={columns}
                saveColumns={handleChangeColumns}
                default={setDefaultLayout}
                title={props.title}
            />
        </Dialog>
    )
}

export default ColumnsManager